<ng-container *notInPopulation="[population.Kids]">
  <div class="d-lg-block d-none">
    <fgb-page-header
      [pageTitle]="'faq.page.title'"
      [showBalance]="false"
      [backButtonLink]="'/'"
    ></fgb-page-header>
  </div>
</ng-container>
<div class="d-lg-none d-block">
  <fgb-page-header
    [pageTitle]="'faq.page.title'"
    [showBalance]="false"
    [backButtonLink]="'/'"
    [showBanner]="false"
  ></fgb-page-header>
</div>

<div class="container">
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
